import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  InputGroup,
  InputGroupAddon,
  Input,
  FormGroup,
  Button,
  Card,
  CardBody,
  CustomInput,
  Table,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

import {
  addVendorsModel_close,
  ClearVendors,
  getVendorData,
  RFQSelectedVendors,
  RFQSelectedAllVendors,
  getVendorsList,
  SetParams,
  addVendors,
  getRFQRequestdata,
} from "../../store/RequetForQuotation/actions";

class AddVendorModel extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 1, search: "" };
  }
  componentDidMount() {
    this.props.getVendorsList({}, false);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }
  autohandleSearch = (e) => {
    this.setState({
      search: e.target.value,
    });
    if (e.target.value === "") {
      this.props.getVendorsList({ search: "" }, false, true);
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getVendorsList(
        {
          search: e.target.value,
        },
        false,
        true
      );
    }
  };
  selectedProductAllVendors(e) {
    this.props.RFQSelectedAllVendors(e.target.checked);
  }
  selectedProductVendors(e, vend, index) {
    this.props.RFQSelectedVendors(e.target.checked, vend, index);
  }
  submitVendors() {
    if (this.props.RFQSelectVendors.length !== 0) {
      if (this.props.AddVendorRFQId !== "0") {
        var vendor_ids = this.props.RFQSelectVendors.map((vend) => {
          return vend.id;
        });

        this.props.addVendors(
          { vendor_ids: vendor_ids, resend: 0 },
          this.props.AddVendorRFQId
        );
        this.props.getRFQRequestdata(this.props.AddVendorRFQId);
        this.props.addVendorsModel_close();
      } else {
        this.props.addVendorsModel_close();
      }
    }
  }
  handleScroll = (e) => {
    const target = e.target;
    if (target.scrollTop !== 0) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (this.props.params.page <= this.props.params.no_of_pages) {
          this.openPage(this.props.params.page + 1);
        }
      }
    }
  };
  openPage(pageNo) {
    this.props.SetParams({
      ...this.props.params,
      page: pageNo,
    });
    this.props.getVendorsList(
      {
        ...this.props.params,
        page: pageNo,
      },
      false
    );
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.addVendorsModel}
          toggle={this.GetVendorslist}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.addVendorsModel_close()}>
            Vendor Details ({this.props.RFQSelectVendors.length})
          </ModalHeader>
          <ModalBody>
            <Row className="justify-content-center p-0">
              <Col md={12} className="pt-0">
                <Nav tabs className="nav-tabs-custom pt-0">
                  <NavItem>
                    <NavLink
                      onClick={() => {
                        this.toggleTab(1);
                      }}
                      className={classnames(
                        { active: this.state.activeTab === 1 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      List | <span>{this.props.vendorsCount}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        { active: this.state.activeTab === 2 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      {this.state.activeTab === 2 && "Details"}
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId={1}>
                    <div className="mt-2">
                      <FormGroup className="m-0">
                        <InputGroup>
                          <Input
                            type="text"
                            name="search"
                            className="form-control d-inline-block"
                            placeholder="Vendors Search"
                            validate={{ required: true }}
                            onChange={(e) => this.autohandleSearch(e)}
                            onKeyDown={(e) => this.handleSearch(e)}
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="light"
                              type="submit"
                              onClick={() =>
                                this.props.getVendorsList(
                                  {
                                    search: this.state.search,
                                  },
                                  false,
                                  true
                                )
                              }
                            >
                              <i className="ri-search-line"></i>
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </div>
                    <div>
                      <div
                        className="table-responsive mt-2"
                        onScroll={this.handleScroll}
                        style={{
                          height: "450px",
                          overflowY: "auto",
                        }}
                      >
                        <Table className="table-centered mb-0">
                          <thead className="bg-light text-center ">
                            <tr>
                              <th style={{ width: "20px" }}>
                                <CustomInput
                                  type="checkbox"
                                  name="vendorsCheck"
                                  id="vendorsCheck"
                                  checked={this.props.allvendorsCheck}
                                  onChange={(e) => {
                                    this.selectedProductAllVendors(e);
                                  }}
                                />
                              </th>
                              <th> Vendors Name</th>
                              <th> Vendors Locations</th>
                            </tr>
                          </thead>
                          <tbody className="text-center">
                            {this.props.vendorslist.length !== 0 ? (
                              <>
                                {this.props.vendorslist.map((vend, key) => (
                                  <tr key={key}>
                                    <td>
                                      <CustomInput
                                        type="checkbox"
                                        name="vendorsCheck"
                                        id={"vendorsCheck" + key}
                                        checked={vend.vendorsCheck}
                                        onChange={(e) => {
                                          this.selectedProductVendors(
                                            e,
                                            vend,
                                            key
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          this.props.getVendorData(vend.id);
                                          this.toggleTab(2);
                                        }}
                                        className="text-dark"
                                      >
                                        {vend.name}
                                      </Link>
                                    </td>
                                    <td>{vend.city}</td>
                                  </tr>
                                ))}
                                {this.props.dataLoading === true && (
                                  <tr className="text-center">
                                    <td colSpan="3">
                                      <Spinner color="primary" />
                                    </td>
                                  </tr>
                                )}
                              </>
                            ) : (
                              <>
                                {this.props.dataLoading === true ? (
                                  <tr className="text-center">
                                    <td colSpan="3">
                                      <Spinner color="primary" />
                                    </td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={3}>
                                      <div className="text-center">
                                        <span className="font-size-18 text-danger">
                                          Vendors not available
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <Row>
                      <Col>
                        <div className="float-right mt-2">
                          <Button
                            type="button"
                            className="btn btn-danger mr-2"
                            color="light"
                            onClick={() => {
                              this.props.ClearVendors();
                              this.props.addVendorsModel_close();
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            type="submit"
                            className="btn btn-primary "
                            color="primary"
                            disabled={
                              this.props.RFQSelectVendors.length !== 0
                                ? false
                                : true
                            }
                            onClick={() => {
                              this.submitVendors();
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={2}>
                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Card>
                          <CardBody>
                            <div className="Order-panel-content">
                              <div className="list-column">
                                <ul className="list-style-two p-1">
                                  <li className="clearfix">
                                    <span className="ttl">Vendor Name:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.name}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">
                                      Vendor Location:{" "}
                                    </span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.city}
                                    </span>
                                  </li>

                                  <li className="clearfix">
                                    <span className="ttl">
                                      Vendor Phone No:
                                    </span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.mobile}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">Email:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.email}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">Address:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.address}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="float-right">
                          <Button
                            type="button"
                            className="btn btn-danger"
                            color="light"
                            onClick={() => {
                              this.toggleTab(1);
                            }}
                          >
                            Back
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    addVendorsModel,
    vendorslist,
    vendorsCount,
    RFQSelectVendors,
    vendordata,
    params,
    AddVendorRFQId,
    dataLoading,
  } = state.RequestForQuotation;

  return {
    addVendorsModel,
    vendorslist,
    vendorsCount,
    RFQSelectVendors,
    vendordata,
    params,
    AddVendorRFQId,
    dataLoading,
  };
};

export default connect(mapStatetoProps, {
  addVendorsModel_close,
  ClearVendors,
  getVendorData,
  RFQSelectedVendors,
  RFQSelectedAllVendors,
  getVendorsList,
  SetParams,
  addVendors,
  getRFQRequestdata,
})(AddVendorModel);
